import {selectChargerCodentify, selectHolderCodentify} from '@/state/selectors/mw';
import {clearHolderData} from '@/state/slices/deviceSlice';
import {clearHolderFwuInfo} from '@/state/slices/fwuSlice';
import {clearHolderMwData} from '@/state/slices/mwSlice';
import {clearUamTokenForCodentify} from '@/state/slices/uamSlice';
import {dispatch, getState} from '@/state/store';

const clearHolderState = () => {
    dispatch(clearHolderData());
    dispatch(clearHolderMwData());
    dispatch(clearHolderFwuInfo());
};

const clearUamTokensForConnectedDevice = () => {
    const state = getState();
    const codentify = selectChargerCodentify(state);
    const holderCodentify = selectHolderCodentify(state);

    if (codentify) {
        dispatch(clearUamTokenForCodentify({codentify}));
    }

    if (holderCodentify) {
        dispatch(clearUamTokenForCodentify({codentify: holderCodentify}));
    }
};

const clearUamTokenForDevice = (isHolder) => {
    const state = getState();
    const codentify = isHolder ? selectHolderCodentify(state) : selectChargerCodentify(state);

    if (codentify) {
        dispatch(clearUamTokenForCodentify({codentify}));
    }
};

export default {
    clearHolderState,
    clearUamTokensForConnectedDevice,
    clearUamTokenForDevice,
};
